import useDropDownSelection from './useDropDownSelection';

const useContactUsSelections = () => {
  const { value: browserSelection, handleSetValue: setBrowserSelection } = useDropDownSelection('');
  const { value: categorySelection, handleSetValue: setCategorySelection } = useDropDownSelection(
    ''
  );
  const { value: deviceSelection, handleSetValue: setDeviceSelection } = useDropDownSelection('');
  const {
    value: operatingSystemSelection,
    handleSetValue: setOperatingSystemSelection,
  } = useDropDownSelection('');
  return {
    browserSelection,
    categorySelection,
    deviceSelection,
    onBrowserSelect: setBrowserSelection,
    onCategorySelect: setCategorySelection,
    onDeviceSelect: setDeviceSelection,
    onOperatingSystemSelect: setOperatingSystemSelection,
    operatingSystemSelection,
  };
};

export default useContactUsSelections;
